import { gql } from '@apollo/client/core';
import { GraphQLFetchPolicy } from '../../graphql/graphql-fetch-policy';
import { apolloClientInternal } from '../../internal/apollo-client-internal';
import type { AIPrompt, CreatePromptInput, UpdatePromptInput } from '../types/ai-prompt';

const AIPromptQueries = {
  loadAll: gql`
    query Prompts {
      prompts {
        prompts {
          id
          title
          prompt
          isPrivate
          entityId
          userId
          createdAt
          updatedAt
        }
      }
    }
  `,
};

const AIPromptMutations = {
  create: gql`
    mutation CreatePrompt($payload: CreatePromptInput!) {
      createPrompt(payload: $payload) {
        id
        title
        prompt
        isPrivate
        entityId
        userId
        createdAt
        updatedAt
      }
    }
  `,

  update: gql`
    mutation UpdatePrompt($payload: UpdatePromptInput!, $promptId: String!) {
      updatePrompt(payload: $payload, promptId: $promptId)
    }
  `,

  delete: gql`
    mutation DeletePrompt($promptId: String!) {
      deletePrompt(promptId: $promptId)
    }
  `,
};

export class AIPromptsService {
  static async loadPrompts(): Promise<AIPrompt[]> {
    const {
      data: {
        prompts: { prompts },
      },
    } = await apolloClientInternal.query({
      query: AIPromptQueries.loadAll,
      fetchPolicy: GraphQLFetchPolicy.NetworkOnly,
    });
    return prompts;
  }

  static async createPrompt(payload: CreatePromptInput): Promise<AIPrompt> {
    const {
      data: { createPrompt },
    } = await apolloClientInternal.mutate({
      mutation: AIPromptMutations.create,
      variables: { payload },
    });
    return createPrompt;
  }

  static async updatePrompt(promptId: string, payload: UpdatePromptInput): Promise<boolean> {
    const {
      data: { updatePrompt },
    } = await apolloClientInternal.mutate({
      mutation: AIPromptMutations.update,
      variables: { promptId, payload },
    });
    return updatePrompt;
  }

  static async deletePrompt(promptId: string): Promise<boolean> {
    const {
      data: { deletePrompt },
    } = await apolloClientInternal.mutate({
      mutation: AIPromptMutations.delete,
      variables: { promptId },
    });
    return deletePrompt;
  }
}
